import React, { useState } from "react";
import { useSearchParams, useNavigate, Link } from "react-router-dom";
import { API_URL } from "../config";
import { toast, ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

/**
 * ResetPassword — user lands here from the reset link.
 * URL: /reset-password?token=xxxxx
 */
function ResetPassword() {
  const [searchParams] = useSearchParams();
  const token = searchParams.get("token");
  const navigate = useNavigate();

  const [password, setPassword] = useState("");
  const [confirm, setConfirm] = useState("");
  const [loading, setLoading] = useState(false);
  const [done, setDone] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (password.length < 8) {
      toast.error("Passordet må være minst 8 tegn.");
      return;
    }
    if ((password.match(/[0-9]/g) || []).length < 2) {
      toast.error("Passordet må inneholde minst 2 tall.");
      return;
    }
    if (!/[!@#$%^&*()_+\-=[\]{};':"\\|,.<>/?~`]/.test(password)) {
      toast.error("Passordet må inneholde minst 1 spesialtegn (!@#$% osv.)");
      return;
    }

    if (password !== confirm) {
      toast.error("Passordene stemmer ikke overens.");
      return;
    }

    setLoading(true);

    try {
      const res = await fetch(`${API_URL}/api/auth/reset-password`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ token, newPassword: password }),
      });

      const data = await res.json();

      if (!res.ok) {
        toast.error(data.error || "Noe gikk galt");
        setLoading(false);
        return;
      }

      setDone(true);
      toast.success("✅ Passordet er oppdatert!");
      setTimeout(() => navigate("/login"), 2000);
    } catch (err) {
      toast.error("Kan ikke koble til serveren.");
    }
    setLoading(false);
  };

  if (!token) {
    return (
      <div className="container d-flex justify-content-center align-items-center" style={{ minHeight: "80vh" }}>
        <div className="card shadow" style={{ width: "420px" }}>
          <div className="card-body p-4 text-center">
            <h3 className="mb-3">❌ Ugyldig lenke</h3>
            <p className="text-muted">Tilbakestillingslenken er ugyldig eller mangler.</p>
            <Link to="/forgot-password" className="btn btn-primary">
              Be om ny lenke
            </Link>
          </div>
        </div>
      </div>
    );
  }

  return (
    <div className="container d-flex justify-content-center align-items-center" style={{ minHeight: "80vh" }}>
      <ToastContainer position="top-center" autoClose={3000} />
      <div className="card shadow" style={{ width: "420px" }}>
        <div className="card-body p-4">
          <h3 className="card-title text-center mb-3">🔒 Nytt passord</h3>

          {done ? (
            <div className="text-center">
              <div className="alert alert-success">
                <strong>✅ Passordet er oppdatert!</strong><br />
                Du blir sendt til innloggingssiden...
              </div>
            </div>
          ) : (
            <>
              <p className="text-muted text-center mb-4">
                Skriv inn ditt nye passord.
              </p>
              <form onSubmit={handleSubmit} noValidate>
                <div className="mb-3">
                  <label htmlFor="reset-password" className="form-label">Nytt passord</label>
                  <input
                    id="reset-password"
                    type="password"
                    className="form-control"
                    placeholder="Minst 8 tegn, 2 tall, 1 spesialtegn"
                    value={password}
                    onChange={(e) => setPassword(e.target.value)}
                    autoComplete="new-password"
                    required
                  />
                  {password.length > 0 && (
                    <ul className="list-unstyled mt-2 mb-0 small">
                      <li className={password.length >= 8 ? "text-success" : "text-danger"}>
                        {password.length >= 8 ? "✅" : "❌"} Minst 8 tegn ({password.length}/8)
                      </li>
                      <li className={(password.match(/[0-9]/g) || []).length >= 2 ? "text-success" : "text-danger"}>
                        {(password.match(/[0-9]/g) || []).length >= 2 ? "✅" : "❌"} Minst 2 tall ({(password.match(/[0-9]/g) || []).length}/2)
                      </li>
                      <li className={/[!@#$%^&*()_+\-=[\]{};':"\\|,.<>/?~`]/.test(password) ? "text-success" : "text-danger"}>
                        {/[!@#$%^&*()_+\-=[\]{};':"\\|,.<>/?~`]/.test(password) ? "✅" : "❌"} Minst 1 spesialtegn (!@#$% osv.)
                      </li>
                    </ul>
                  )}
                </div>
                <div className="mb-3">
                  <label htmlFor="reset-confirm" className="form-label">Bekreft passord</label>
                  <input
                    id="reset-confirm"
                    type="password"
                    className="form-control"
                    placeholder="Skriv passordet på nytt"
                    value={confirm}
                    onChange={(e) => setConfirm(e.target.value)}
                    autoComplete="new-password"
                    required
                  />
                  {confirm.length > 0 && (
                    <small className={password === confirm ? "text-success" : "text-danger"}>
                      {password === confirm ? "✅ Passordene stemmer overens" : "❌ Passordene stemmer ikke overens"}
                    </small>
                  )}
                </div>
                <button type="submit" className="btn btn-primary w-100" disabled={loading}>
                  {loading ? "Oppdaterer..." : "🔒 Oppdater passord"}
                </button>
              </form>
            </>
          )}
        </div>
      </div>
    </div>
  );
}

export default ResetPassword;
